import { useState, useEffect, useContext } from "react";
import { AvailabilityContext } from "../Contexts/AvailabilityContext";

export default function useShipping(country, cartItems) {
  const { shipping: shippingData } = useContext(AvailabilityContext);
  const [shippingCost, setShippingCost] = useState(0);

  const getShippingCost = countryName => {
    const found = shippingData.find(c => c.name === countryName);
    return found ? found.shipping : 0;
  };

  useEffect(() => {
    setShippingCost(country ? getShippingCost(country) : 0);
  }, [country, shippingData]);

  const parsePrice = priceString => parseFloat(priceString.replace(/[^0-9.]/g, ""));

  const totalWithoutShipping = cartItems.reduce(
    (sum, item) => sum + parsePrice(item.price) * (item.quantity || 1),
    0
  );

  const total = totalWithoutShipping + shippingCost;
  const countries = shippingData.map(c => c.name).sort((a, b) => a.localeCompare(b));

  return { shippingCost, totalWithoutShipping, total, countries };
}
